import { data } from '../../svg/FilterAltOff/data';
import { makeIcon } from '../makeIcon';

export const FilterAltOff = makeIcon(data, 'filter_alt_off', 'FilterAltOff');

export default FilterAltOff;
